import { gql } from '@apollo/client'

export const REFRESH_WORKSPACE_INVITATION = gql`
  mutation RefreshWorkspaceInvitation($token: String!) {
    refreshWorkspaceInvitation(token: $token) {
      success
    }
  }
`
